import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function Policy() {
  return (
    <div className="min-h-screen bg-[#F8FAFC] font-sans flex flex-col">
      <Header />
      <main className="flex-1 px-4 md:px-24 py-12 w-full max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold text-[#172554] text-gujarati mb-2 text-center">
          નીતિઓ અને નિયમો (Privacy Policy & Terms)
        </h2>
        <div className="w-24 h-1 bg-[#F5B800] mx-auto mb-10 rounded"></div>
        
        <div className="bg-white p-8 rounded-xl shadow-sm border border-[#E2E8F0] text-gujarati text-[#172033] flex flex-col gap-6 leading-relaxed">
          
          <section>
            <h3 className="text-xl font-bold text-[#172554] mb-3">1. પ્રસ્તાવના (Introduction)</h3>
            <p className="text-[#64748B]">
              કાગજબુક ઓનલાઈન (Kagajbook Online) માં આપનું સ્વાગત છે. આ નીતિ અમારા વપરાશકર્તાઓની માહિતી કેવી રીતે સંગ્રહિત, ઉપયોગમાં અને સુરક્ષિત કરવામાં આવે છે તે સ્પષ્ટ કરે છે. 
              અમારી સેવાઓનો ઉપયોગ કરીને, તમે આ નીતિઓને અનુસરવા સંમત થાઓ છો.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-bold text-[#172554] mb-3">2. માહિતી સંગ્રહ (Data Collection)</h3>
            <p className="text-[#64748B] mb-2">
              અમે નીચે મુજબની માહિતી એકત્રિત કરી શકીએ છીએ:
            </p>
            <ul className="list-disc list-inside ml-5 text-[#64748B] space-y-1">
              <li>નામ, મોબાઈલ નંબર, અને ઈમેલ એડ્રેસ.</li>
              <li>અરજી માટે જરૂરી દસ્તાવેજો (જેમ કે પાન કાર્ડ, આધાર કાર્ડ, વગેરે).</li>
              <li>અરજીની સ્થિતિ અને ચુકવણીની વિગતો (અમે કોઈપણ ક્રેડિટ કાર્ડ કે બેંક પાસવર્ડ સંગ્રહિત કરતા નથી).</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-bold text-[#172554] mb-3">3. માહિતીનો ઉપયોગ (Data Usage)</h3>
            <p className="text-[#64748B]">
              અમે એકત્રિત કરેલી માહિતીનો ઉપયોગ ફક્ત તમારી અરજી પ્રક્રિયા પૂર્ણ કરવા, તમને જરૂરી દસ્તાવેજો મોકલવા અને સહાય પૂરી પાડવા માટે કરીએ છીએ. તમારી અંગત માહિતી ક્યારેય કોઈપણ ત્રીજા પક્ષને વેચવામાં આવતી નથી.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-bold text-[#172554] mb-3">4. દસ્તાવેજોની સુરક્ષા (Data Security)</h3>
            <p className="text-[#64748B]">
              તમે અપલોડ કરેલા તમામ દસ્તાવેજો સુરક્ષિત ક્લાઉડ સ્ટોરેજ પર સંગ્રહિત કરવામાં આવે છે. અરજી પૂર્ણ થયા પછી અને તમને તમારો દસ્તાવેજ મળી ગયા પછી, તમે ઇચ્છો તો તેને દૂર કરવાની વિનંતી કરી શકો છો.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-bold text-[#172554] mb-3">5. રદ્દીકરણ અને રિફંડ નીતિ (Cancellation & Refund Policy)</h3>
            <p className="text-[#64748B]">
              જો અરજી પ્રક્રિયામાં કોઈ ભૂલ થઈ હોય અથવા સેવા પૂરી પાડવામાં ન આવે, તો રિફંડ માટે વિનંતી કરી શકાય છે. જો અરજી સરકારી વિભાગમાં જમા થઈ ગઈ હોય, તો રિફંડ શક્ય રહેશે નહીં.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-bold text-[#172554] mb-3">6. સંપર્ક (Contact Us)</h3>
            <p className="text-[#64748B]">
              જો તમને આ નીતિઓ અંગે કોઈ પ્રશ્નો હોય, તો કૃપા કરીને અમારો સંપર્ક કરો:<br/><br/>
              <b>ઇમેઇલ:</b> kagajbook@gmail.com<br/>
              <b>ફોન:</b> +91 90811 10022
            </p>
          </section>

        </div>
      </main>
      <Footer />
    </div>
  );
}
